import { Location, Route } from 'vue-router'
import { applicantStore } from '@/store'

export class RouterUtils {
    static isApplicationKeep (to: Route, from: Route, fromName: string): boolean {
        const personCodeMatches = from.params.personCodeFromUrl === to.params?.personCodeFromUrl
        return !!(from.name === fromName && personCodeMatches)
    }

    static setSummaryRoute (pathName: string, personCode: string): Location | undefined {
        return !applicantStore.isValidApplicant
            ? {
                name: pathName,
                params: { personCodeFromUrl: personCode }
            }
            : undefined
    }

    static queryParamToBool (value: string | Array<string | null>): boolean {
        if (typeof value === 'string') {
            return value.toLowerCase() === 'true' || value === '1'
        }
        return false
    }

    static setFocusToBody (): void {
        document.body.setAttribute('tabindex', '-1')
        document.body.focus()
        document.body.removeAttribute('tabindex')
    }

    static setFocusToElement (elementQuery: string): void {
        const element: HTMLElement | null = document.querySelector(elementQuery)
        if (element != null) {
            element.setAttribute('tabindex', '-1')
            element.focus()
            element.removeAttribute('tabindex')
        }
    }
}
